
window.openHeaderDrawer = function () {
  let drawer;
   drawer = document.querySelector('.--regular-header-drawer-mobile');



  if (!drawer) {
    console.log("Drawer Not found");
    return;
  }

  drawer.classList.add('active');
  document.querySelector('.--drawer-overlay')?.classList.add('active');
  document.body.style.overflow = "hidden";
}
window.closeHeaderDrawer = function (){
   let drawer;
   drawer = document.querySelector('.--regular-header-drawer-mobile');
  // if (window.innerWidth < 768) {
  //   drawer = document.querySelector('.--regular-header-drawer-mobile');
  // } else {
  //   drawer = document.querySelector('.--regular-header-drawer');
  // }
  // let drawer = document.querySelector('.--regular-header-drawer');
  if(!drawer){
    console.log("Drawer Not found");
    return;
  }
  drawer.classList.remove('active');
  document.querySelector('.--drawer-overlay')?.classList.remove('active');
  document.body.style.overflow = "";
}
window.toggleMenuAccordion = function (item) {
  let parentLi = item.closest('li');
  if (!parentLi) {
    return;
  }

  if (parentLi.classList.contains('--accordion-active')) {
    parentLi.classList.remove('--accordion-active');
  } else {
    parentLi.classList.add('--accordion-active');
  }
};


document.addEventListener('DOMContentLoaded', function () {


  // Hover Icons on Header start
    const accountIcons = document.querySelectorAll('.--account-icon');

    accountIcons.forEach((icon) => {
      const parentLi = icon.closest('.--account-icon-wrapper');
      const parentUl = icon.closest('.--right-column-desktop');
      const accountLinks = parentLi?.querySelector('.--account-links');

      if (accountLinks) {
        parentLi.addEventListener('mouseenter', function () {
          accountLinks.classList.add('--active-account-links');
        });
         parentUl.addEventListener('mouseleave', function () {
          accountLinks.classList.remove('--active-account-links');
        });
        // parentLi.addEventListener('mouseleave', function () {
        //   accountLinks.classList.remove('--active-account-links');
        // });
      }
    });
     // Hover Icons on Header End

  let popularCardSwiper = document.querySelector(
    ".--popular-product-wrapper .swiper.--popular-product-slider"
  );

  if (popularCardSwiper) {
    new Swiper(popularCardSwiper, {
      slidesPerView: 2.5,
      spaceBetween: 40,
      loop: true,
      // freeMode: true,
     
      speed: 700, // Adjust the speed for smooth scrolling 
      // autoplay: {
      //   delay: 1500, // No delay, continuous scroll
      //   disableOnInteraction: false,
      // }, 
      
      breakpoints: {
        600: {
          slidesPerView: 4,
          slidesPerGroup: 4,
          // spaceBetween: 30,
        },
      },
    }); 
  }
  let burgerReviewSlider = document.querySelector(
    ".--regular-header-drawer .swiper.--burger-review-slider"
  );

  if (burgerReviewSlider) {
    new Swiper(burgerReviewSlider, {
      slidesPerView: 1.2,
      spaceBetween: 12,
      loop: true,
      // freeMode: true,
     
      speed: 700, // Adjust the speed for smooth scrolling 
      // autoplay: {
      //   delay: 1500, // No delay, continuous scroll
      //   disableOnInteraction: false,
      // }, 
      
      breakpoints: {
        600: {
          slidesPerView: 2.1,
          // slidesPerGroup: 3,
          spaceBetween: 12,
        },
      },
    }); 
  }
 

 






// DOMContentLoaded End
  });


// Define the sticky header function on the window object
window.stickyHeader = function () {
  // const header = document.querySelector('#shopify-section-maze-recovery-header');
  const header = document.querySelector('section.--regular-header .--regular-header-wrapper');
  if(!header){
    return;
  }
  // Add scroll event listener
  window.addEventListener('scroll', () => {
    if (window.scrollY > header.offsetTop) {
      header.classList.add('is-sticky');
    } else {
      header.classList.remove('is-sticky');
    }
  });
};

// Call the function when DOM content is loaded
document.addEventListener('DOMContentLoaded', () => {
  window.stickyHeader();
});



// Codes for mobile header drawer 
function applyTransitionDelay(megamenu_container) {
  const megaMenuItems = megamenu_container;
  const megaChildItems =
    megamenu_container.querySelectorAll(".--megamenu-card");

  megaChildItems.forEach((item, index) => {
    const delay = (index / megaChildItems.length) * 0.5;
    item.style.transitionDelay = `${delay}s`;
  });

  // megaMenuItems.forEach((item, index) => {
  //   const delay = 0.5 + (index / megaMenuItems.length) * 0.5;
  //   item.style.transitionDelay = `${delay}s`;
  // });
}

function removeTransitionDelay(megamenu_container) {
  const megaMenuItems = megamenu_container;
  const megaChildItems =
    megamenu_container.querySelectorAll(".--megamenu-card");

  // megaMenuItems.forEach((item) => (item.style.transitionDelay = ""));
  megaChildItems.forEach((item) => (item.style.transitionDelay = ""));
}

document.addEventListener("DOMContentLoaded", () => {
  let megamenu_triggers = document.querySelectorAll(
    ".--nav-item.item__mega-link"
  );
  let mobile_megamenu_triggers = document.querySelectorAll(
    ".--mobile-nav-wrapper .plus"
  );
  let mobile_close_megamenu_triggers = document.querySelectorAll(
    ".--mobile-nav-wrapper .minus"
  );
  let megamenu_containers = document.querySelectorAll(".--mega-menu-container");

  // Add event listeners for each trigger
  megamenu_triggers.forEach((megamenu_trigger) => {
    let closeTimeout;

    megamenu_trigger.addEventListener("mouseenter", () => {
      // Clear any previous close timeout when entering the trigger
      if (closeTimeout) {
        clearTimeout(closeTimeout);
      }

      // Open the corresponding mega menu
      megamenu_containers.forEach((megamenu_container) => {
        if (
          megamenu_trigger.dataset.title === megamenu_container.dataset.title
        ) {
          megamenu_container.classList.add("active-mega-menu");
          applyTransitionDelay(megamenu_container);
        }
      });
    });

    megamenu_trigger.addEventListener("mouseleave", () => {
      // Delay closing the mega menu when mouse leaves the trigger
      closeTimeout = setTimeout(() => {
        megamenu_containers.forEach((megamenu_container) => {
          if (
            megamenu_trigger.dataset.title === megamenu_container.dataset.title
          ) {
            megamenu_container.classList.remove("active-mega-menu");
            removeTransitionDelay(megamenu_container);
          }
        });
      }, 300); // Adjust delay as necessary
    });
  });
  // // Add event listeners for each trigger mobile
  // mobile_megamenu_triggers.forEach((megamenu_trigger) => {
  //   let closeTimeout;

  //   megamenu_trigger.addEventListener("click", () => {
  //     let parent = megamenu_trigger.closest('.--mobile-mega-menu-controls');
  //     parent.classList.add("active-control");
  //     // Clear any previous close timeout when entering the trigger
  //     if (closeTimeout) {
  //       clearTimeout(closeTimeout);
  //     }

  //     // Open the corresponding mega menu
  //     megamenu_containers.forEach((megamenu_container) => {
  //       if (
  //         megamenu_trigger.dataset.title === megamenu_container.dataset.title
  //       ) {
  //         megamenu_container.classList.add("active-mega-menu");
  //         applyTransitionDelay(megamenu_container);
  //       }
        
  //     });
  //   });
  // });
  // Add event listeners for each mobile mega menu trigger
mobile_megamenu_triggers.forEach((megamenu_trigger) => {
  megamenu_trigger.addEventListener("click", () => {
    let parent = megamenu_trigger.closest(".--mobile-mega-menu-controls");
    let currentTitle = megamenu_trigger.dataset.title;

    // Close all other controls
    document
      .querySelectorAll(".--mobile-mega-menu-controls.active-control")
      .forEach((control) => {
        if (control !== parent) {
          control.classList.remove("active-control");
        }
      });

    // Activate current control
    parent?.classList.add("active-control");

    // Close all other mega menus and open the matching one
    megamenu_containers.forEach((megamenu_container) => {
      if (megamenu_container.dataset.title === currentTitle) {
        megamenu_container.classList.add("active-mega-menu");
        applyTransitionDelay(megamenu_container);
      } else {
        megamenu_container.classList.remove("active-mega-menu");
        removeTransitionDelay(megamenu_container);
      }
    });
  });
});
  // Add event listeners for each trigger in mobile to close megamenu
  // mobile_close_megamenu_triggers.forEach((megamenu_trigger) => {
  //   let closeTimeout;

  //   megamenu_trigger.addEventListener("click", () => {
  //     let parent = megamenu_trigger.closest('.--mobile-mega-menu-controls');
  //     parent.classList.remove("active-control");
  //     closeTimeout = setTimeout(() => {
  //       megamenu_containers.forEach((megamenu_container) => {
  //         if (
  //           megamenu_trigger.dataset.title === megamenu_container.dataset.title
  //         ) {
  //           megamenu_container.classList.remove("active-mega-menu");
  //           removeTransitionDelay(megamenu_container);
  //         }
  //       });
  //     }, 300); // Adjust delay as necessary
  //   });
  // });
  // Close mega menu
  mobile_close_megamenu_triggers.forEach((megamenu_trigger) => {
    megamenu_trigger.addEventListener("click", () => {
      const parent = megamenu_trigger.closest(".--mobile-mega-menu-controls");
      const currentTitle = megamenu_trigger.dataset.title;

      parent?.classList.remove("active-control");

      setTimeout(() => {
        megamenu_containers.forEach((megamenu_container) => {
          if (megamenu_container.dataset.title === currentTitle) {
            megamenu_container.classList.remove("active-mega-menu");
            removeTransitionDelay(megamenu_container);
          }
        });
      }, 300);
    });
  });
});